export const VENNIE_PROCESSED_STATUSES = [
  'address change rejected',
  'address change successful', 
  'pending approval',
  'staff asked to approve order refund',
  'return policy response generated',
  'order status URLs provided',
  'tracking information provided',
  'Answered product information question',
  'Answered product availability question',
  'bot generated answer',
  'ask order number',
  'ask shipping address',
  'No order found with name',
  'Multiple orders found, asked customer to pick one',
  'Item replacement image check rejected',
  'Request images from customer',
  'replacement order successfully created',
  'duplicate refund / replace request by customer',
  'Item replacement image check requested',
  'Voucher offered to customer',
  'Voucher created',
  'multiple orders response generated',
  'Processing opt in requested',
  'The ticket is solved, no action required',
];

export const VENNIE_NOT_PROCESSED_STATUSES = [
  'address update failed',
  'Order cancel - not enough info in policies for an answer',
  'Not enough info to generate return policy response',
  'order tracking info not found',
  'custom human action - tracking already sent',
  'Order not shipped response already sent',
  'Cannot decide on product info action',
  'Custom human action needed',
  'No relevant policies found',
  'Policy already used, a human agent needs to take over.',
  'Not enough information to form final answer',
  'ignore - solved answer disabled',
  'IGNORE - order number already asked',
  'order not found',
  'Not enough info to make a return decision',
  'replacement error - same item replacement and vouchers are disabled.',
  'replacement error - customer or product not found',
  'replacement error - item variant not found',
  'Voucher - customer declined voucher.',
  'Failed to find orders',
  'IGNORE - recipient email doesnt match support email',
  'Processing opt in REJECTED',
  'The ticket is closed, no action required',
  'Processing opt out REJECTED',
  'Vennie has ignored this message. Reason - exclusion rule <STARTS WITH>',
  'IGNORE - agent is ignoring bot',
  'IGNORE - ticket actioned by agent before bot',
  'The first message is from an Agent.',
  'ignore - angry customer',
  'not support ticket',
  'ignore - repeated question',
  'Human agent needs to take over',
  'System determined that available policies don\'t contain enough information to answer'
];

export const SUGGESTION_SUBTYPES = {
  'non_defective_return_policy': {
    'id': 'non_defective_return_policy',
    'label': 'Non-Defective Return Policy',
    'description': 'Return policy for non-defective items',
    'category': 'Returns, Replacements and Refunds',
    'is_action': false,
    'action_category': 'RETURNS_REPLACEMENTS_REFUNDS'
  }
  ,
  'policy_answer_response': {
    'id': 'policy_answer_response',
    'label': 'Policy Answer Response',
    'description': 'General policy related responses',
    'category': 'Answering',
    'is_action': false,
    'action_category': 'ANSWERING'
  },
  'policy_answer_solved_response': {
    'id': 'policy_answer_solved_response', 
    'label': 'Policy Answer Solved Response',
    'description': 'Final response when marking ticket as solved',
    'category': 'Answering',
    'is_action': false,
    'action_category': 'ANSWERING'
  },
  'change_address_rejection': {
    'id': 'change_address_rejection',
    'label': 'Address Change Rejection',
    'description': 'Response when address change is not possible',
    'category': 'Address Change',
    'is_action': false,
    'action_category': 'ADDRESS_CHANGE'
  },
  'change_address_success': {
    'id': 'change_address_success',
    'label': 'Address Change Success',
    'description': 'Response when address is successfully changed',
    'category': 'Address Change',
    'is_action': false,
    'action_category': 'ADDRESS_CHANGE'
  },
  'order_cancel_shipped_order_policy_response': {
    'id': 'order_cancel_shipped_order_policy_response',
    'label': 'Shipped Order Cancel Policy',
    'description': 'Return policy for shipped orders',
    'category': 'Order Cancel',
    'is_action': false,
    'action_category': 'ORDER_CANCEL'
  },
  'order_refund_cancel_success': {
    'id': 'order_refund_cancel_success',
    'label': 'Order Cancel Success',
    'description': 'Response about successful order cancellation',
    'category': 'Order Cancel',
    'is_action': false,
    'action_category': 'ORDER_CANCEL'
  },
  'order_status_response': {
    'id': 'order_status_response',
    'label': 'Order Status Response',
    'description': 'Response about order status',
    'category': 'Order Tracking',
    'is_action': false,
    'action_category': 'ORDER_TRACKING'
  },
  'order_tracking_response': {
    'id': 'order_tracking_response',
    'label': 'Order Tracking Response',
    'description': 'Response about order tracking',
    'category': 'Order Tracking',
    'is_action': false,
    'action_category': 'ORDER_TRACKING'
  },
  'product_info_answer': {
    'id': 'product_info_answer',
    'label': 'Product Information Answer',
    'description': 'Response about product details',
    'category': 'Products',
    'is_action': false,
    'action_category': 'PRODUCTS'
  },
  'product_availability_response': {
    'id': 'product_availability_response',
    'label': 'Product Availability Response',
    'description': 'Response about product availability',
    'category': 'Products',
    'is_action': false,
    'action_category': 'PRODUCTS'
  },
  'ask_order_number': {
    'id': 'ask_order_number',
    'label': 'Ask Order Number',
    'description': 'Request for order number',
    'category': 'More Information',
    'is_action': false,
    'action_category': 'MORE_INFORMATION'
  },
  'ask_shipping_address': {
    'id': 'ask_shipping_address',
    'label': 'Ask Shipping Address',
    'description': 'Request for shipping address',
    'category': 'More Information',
    'is_action': false,
    'action_category': 'MORE_INFORMATION'
  },
  'no_order_found_with_name': {
    'id': 'no_order_found_with_name',
    'label': 'No Order Found',
    'description': 'Response when order cannot be found',
    'category': 'More Information',
    'is_action': false,
    'action_category': 'MORE_INFORMATION'
  },
  'order_refund_replace_image_rejection': {
    'id': 'order_refund_replace_image_rejection',
    'label': 'Refund/Replace Image Rejection',
    'description': 'Response when images are rejected',
    'category': 'Returns, Replacements and Refunds',
    'is_action': false,
    'action_category': 'RETURNS_REPLACEMENTS_REFUNDS'
  },
  'order_refund_replace_image_request': {
    'id': 'order_refund_replace_image_request',
    'label': 'Request Images for Refund/Replace',
    'description': 'Request for images of defective item',
    'category': 'Returns, Replacements and Refunds',
    'is_action': false,
    'action_category': 'RETURNS_REPLACEMENTS_REFUNDS'
  },
  'order_refund_replace_success': {
    'id': 'order_refund_replace_success',
    'label': 'Refund/Replace Success',
    'description': 'Confirmation of refund or replacement',
    'category': 'Returns, Replacements and Refunds',
    'is_action': false,
    'action_category': 'RETURNS_REPLACEMENTS_REFUNDS'
  },
  'return_tracking_status': {
    'id': 'return_tracking_status',
    'label': 'Return Tracking Status',
    'description': 'Response about return tracking status',
    'category': 'Returns, Replacements and Refunds',
    'is_action': false,
    'action_category': 'RETURNS_REPLACEMENTS_REFUNDS'
  },
  'order_refund_replace_voucher_request': {
    'id': 'order_refund_replace_voucher_request',
    'label': 'Refund Voucher Request',
    'description': 'Offer of refund voucher',
    'category': 'Returns, Replacements and Refunds',
    'is_action': false,
    'action_category': 'RETURNS_REPLACEMENTS_REFUNDS'
  },
  'refund_voucher_issued': {
    'id': 'refund_voucher_issued',
    'label': 'Refund Voucher Issued',
    'description': 'Confirmation of voucher issuance',
    'category': 'Returns, Replacements and Refunds',
    'is_action': false,
    'action_category': 'RETURNS_REPLACEMENTS_REFUNDS'
  },
  'refund_replace_rejection': {
    'id': 'refund_replace_rejection',
    'label': 'Refund/Replace Rejection',
    'description': 'Response when refund/replace request is rejected',
    'category': 'Returns, Replacements and Refunds',
    'is_action': false,
    'action_category': 'RETURNS_REPLACEMENTS_REFUNDS'
  }
}